module.exports = __webpack_public_path__ + "img/motorway_6x1_z18.37c98af5.svg";